import { removeCookie } from 'js/utils/cookie.util';
import { getBaseDomain } from 'js/utils/url.util';

export const getCookiesList = (cookieGroups = [], cookiesStorageData = {}) => {
    const cookiesArray = cookieGroups
        .filter((item) => item.enabled && !cookiesStorageData[item.group] && Boolean(item.names))
        .map((item) => item.names);

    return cookiesArray.length
        ? cookiesArray.join(',').split(',')
            .map(cookie => cookie.trim())
        : cookiesArray;
};

export const clearCookies = (cookiesList, pathLang = '') => cookiesList.forEach((cookie) => {
    removeCookie(cookie, { path: `/${pathLang}` });
    removeCookie(cookie, { path: `/${pathLang}`, domain: getBaseDomain() });
});

export const parseCookiesGroups = (cookiesData = []) =>
    cookiesData.reduce((obj, item) => item.enabled && item.group !== 'system'
            ? { ...obj, [item.group]: false }
            : obj,
        {});

export const prepareCookiesGroups = (defaultGroups, storageGroups) =>
    Object.keys(defaultGroups).reduce((acc, key) => ({
        ...acc,
        [key]: typeof storageGroups[key] === 'boolean' ? storageGroups[key] : defaultGroups[key]
    }), {});

export const parseSearchParametersGroups = (cookiesData = [], search) => {
    const searchParams = new URLSearchParams(search);

    return cookiesData
        .reduce((obj, item) => item.enabled && item.group !== 'system' && searchParams.has(`cookieLayer.${item.group}`)
            ? { ...obj, [item.group]: searchParams.get(`cookieLayer.${item.group}`) === '1' }
            : obj,
        {});
};
